import React from "react";
import { Link } from "react-router-dom";

export const renewMembersColumns = ({
  handleRenew,
  handleCancelled,
  ageCalculate,
}) => [
  {
    label: "P ID",
    width: 80,
    render: (row) => (
      <Link to="#">
        {row?.profile_id || "-"}
      </Link>
    ),
  },

  {
    label: "User Details",
    render: (row) => (
      <div className="userdet">
        <div>
          <i className="far fa-user" /> {row?.name || "-"}
        </div>
        <div>
          <i className="far fa-mobile" /> {row?.contact_no || "-"}
        </div>
        <div>
          <i className="far fa-envelope" /> {row?.contact_email || "-"}
        </div>
        <div>
          <i className="far fa-mars" /> {row?.gender || "-"}
        </div>
        <div>
          <i className="far fa-calendar-alt" />{" "}
          {row?.dob ? `${ageCalculate(row.dob)} Yrs old` : "-"}
        </div>
      </div>
    ),
  },

  {
    label: "Membership Plan",
    render: (row) => {
      // compute the expiry using userPlan if available
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const expiryDate = row?.userPlan?.expiry_date
        ? new Date(row.userPlan.expiry_date)
        : null;

      if (expiryDate) {
        expiryDate.setHours(0, 0, 0, 0);
      }

      const showCancelLink =
        (row.userPlan?.status === "Paid" && expiryDate && expiryDate > today) ||
        row?.membershipPlan?.name === "VIP";

      return (
        <div>
          <div>{row?.membershipPlan?.name || "-"}</div>
          
          <br />
          {showCancelLink && (
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                handleCancelled(row, "Cancelled");
              }}
            >
              Cancel Membership
            </Link>
          )}
        </div>
      );
    },
  },

  {
    label: "Expiry Date",
    render: (row) =>
      row?.userPlan?.expiry_date
        ? new Date(row.userPlan.expiry_date).toLocaleDateString()
        : "-",
  },

  {
  label: "Status",
  render: (row) => {
    if (!row?.userPlan?.expiry_date) {
      return <span className="text-danger">----</span>;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const expiry = new Date(row.userPlan.expiry_date);
    expiry.setHours(0, 0, 0, 0);

    const isActive = expiry >= today;

    return (
      <div className="checkbox-wrapper-8">
        <input
          className="tgl tgl-skewed"
          type="checkbox"
          checked={isActive}
          readOnly
        />
        <label
          className="tgl-btn"
          data-tg-off="Expired"
          data-tg-on="Active"
        />
      </div>
    );
  },
},

  {
    label: "Action",
    render: (row) => (
      (row?.userPlan?.expiry_date && row?.userPlan?.expiry_date > new Date() && (
      <Link
        to="#"
        onClick={() => handleRenew(row)}
        className="sitebtn text-white text-center px-2 py-1 m-2 d-inline-block"
        style={{ textDecoration: "none" }}
      >
        Renew
      </Link>
      ) || <span className="text-danger">----</span>)

    ),
  },
];